import { axiosInstance } from '~/api/base'
import { NGM_API_BASE_PATH, buildNgmHeaders } from '~/api/ngm'
import type { NgmClusterContext } from '~/api/ngm'

export { buildNgmHeaders, ngmContextFromCluster } from '~/api/ngm'
export type { NgmClusterContext } from '~/api/ngm'

export interface TopruSummaryItem {
  sql_digest?: string
  sql_text?: string
  total_ru?: number
  exec_count?: number
  duration_ns?: number
  exec_count_per_sec?: number
  duration_per_exec_ms?: number
  timestamp_sec?: number[]
  total_ru_by_time?: number[]
}

export interface TopruSummaryPlanItem extends TopruSummaryItem {
  plan_digest?: string
  plan_text?: string
}

export interface TopruSummaryEnvelope {
  status?: string
  data?: TopruSummaryItem[]
}

export interface TopruSummaryPlanEnvelope {
  status?: string
  data?: TopruSummaryPlanItem[]
}

export interface TopruUserStatsItem {
  user?: string
  total_ru?: number
  exec_count?: number
  duration_ns?: number
}

export interface TopruUserStatsEnvelope {
  status?: string
  data?: TopruUserStatsItem[]
}

export interface TopruConfigResponse {
  enable?: boolean
}

export interface GetTopruSummaryParams {
  start: string
  end: string
  top: string
  order_by: string
  step: number
  user?: string
}

export interface GetTopruSummaryPlanParams {
  start: string
  end: string
  top: string
  digest?: string
  order_by: string
  step: number
  user?: string
}

export interface GetTopruUserStatsParams {
  start: string
  end: string
  top: string
}

function buildQs(params: object): string {
  const usp = new URLSearchParams()
  Object.entries(params as Record<string, unknown>).forEach(([key, value]) => {
    if (value === undefined || value === null) return
    if (value === '' && key !== 'user') return
    usp.set(key, String(value))
  })
  return usp.toString()
}

export function getTopruConfig(ctx: NgmClusterContext) {
  return axiosInstance
    .get<TopruConfigResponse>(`${NGM_API_BASE_PATH}/topru/config`, {
      headers: buildNgmHeaders(ctx)
    })
    .then((res) => res.data)
}

export function getTopruSummary(
  ctx: NgmClusterContext,
  params: GetTopruSummaryParams
) {
  return axiosInstance
    .get<TopruSummaryEnvelope>(
      `${NGM_API_BASE_PATH}/topru/summary?${buildQs(params)}`,
      {
        headers: buildNgmHeaders(ctx)
      }
    )
    .then((res) => res.data)
}

export function getTopruSummaryPlan(
  ctx: NgmClusterContext,
  params: GetTopruSummaryPlanParams
) {
  return axiosInstance
    .get<TopruSummaryPlanEnvelope>(
      `${NGM_API_BASE_PATH}/topru/summaryplan?${buildQs(params)}`,
      {
        headers: buildNgmHeaders(ctx)
      }
    )
    .then((res) => res.data)
}

export function getTopruUserStats(
  ctx: NgmClusterContext,
  params: GetTopruUserStatsParams
) {
  return axiosInstance
    .get<TopruUserStatsEnvelope>(
      `${NGM_API_BASE_PATH}/topru/user_stats?${buildQs(params)}`,
      {
        headers: buildNgmHeaders(ctx)
      }
    )
    .then((res) => res.data)
}
